<template>
  <div v-if="chartShow" class="row align-items-center">
    <div class="col-5 mx-auto">
      <RadarChart
        class="max-width-650"
        :chart-data="chartGameData"
        :options="chartOptions"
      />
    </div>

    <div class="col-5 mx-auto">
      <ArrayTable :dataTable="dataTableGames" />
    </div>
  </div>
</template>

<script>
  import RadarChart from '../charts/Radar.js'
  import ArrayTable from '../divers/ArrayTable.vue'

  export default {
    components: { RadarChart, ArrayTable },
    props: ['data'],
    data() {
      return {
        chartShow: false,

        chartGameData: {
          labels: [],
          datasets: [
            {
              label: 'Jeu en %',
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              borderColor: 'rgb(255, 99, 132)',
              pointBackgroundColor: 'rgb(255, 99, 132)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgb(255, 99, 132)',
              fill: true,
              data: [],
            },
          ],
        },
        chartOptions: {
          scale: {
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 10,
              stepSize: 10, // Optionnel, définit l'incrément des ticks
            },
          },
          legend: {
            display: false, // Masquer la légende
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let dataset = data.datasets[tooltipItem.datasetIndex]
                let label = data.labels[tooltipItem.index]
                let value = dataset.data[tooltipItem.index]
                return label + ': ' + value + '%'
              },
              title: function (tooltipItem, data) {
                let label = data.labels[tooltipItem.index]
                console.log(label)
                return label
              },
            },
          },
        },
        dataTableGames: {
          items: [],
          fields: [
            { key: 'id', label: 'ID', sortable: true },
            { key: 'name', label: 'Nom', sortable: true },
            { key: 'total', label: 'Total', sortable: true },
            { key: 'totalPerCent', label: 'Total %', sortable: true },
          ],
        },
      }
    },
    methods: {
      readGamesChart() {
        let games = this.data.name
        let totalGame =
          this.data.totalGameInstances.length > 0
            ? this.data.totalGameInstances[0].total
            : 0
        for (let index = 0; index < games.length; index++) {
          let game = games[index]
          if (index < 6) {
            this.chartGameData.labels.push(game._id)
            this.chartGameData.datasets[0].data.push(
              Math.floor((game.count * 100) / totalGame)
            )
          }
          let valueItem = {
            id: index + 1,
            name: game._id,
            total: game.count,
            totalPerCent: Math.floor((game.count * 100) / totalGame),
          }
          if (
            (game.count * 100) / totalGame >
            this.chartOptions.scale.ticks.max
          ) {
            this.chartOptions.scale.ticks.max =
              Math.ceil((game.count * 100) / totalGame / 10) * 10
          }
          this.dataTableGames.items.push(valueItem)
        }
        this.chartShow = true
      },
    },
    mounted() {
      this.readGamesChart()
    },
  }
</script>

<style scoped>
  .max-width-650 {
    max-width: 650px;
  }
</style>
